// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-title {
    width: 100%;
    height: 65px;
    padding: 10px 0;
}
.row {
    margin-right: -10px;
    margin-left: -10px;
}
.companiesViewleft {
    text-align: center;
    background-color: #fff!important;
    border: 1px solid #dfdfdf!important;
}
.x_panel {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
    padding: 10px 17px;
    display: inline-block;
    background: #fff;
    border: 1px solid #E6E9ED;
    -webkit-column-break-inside: avoid;
    -moz-column-break-inside: avoid;
    /* column-break-inside: avoid; */
    opacity: 1;
    transition: all .2s ease;
}
.x_title {
    border-bottom: 2px solid #E6E9ED;
    padding: 1px 5px 6px;
    margin-bottom: 10px;
}
.companiesViewleft {
    text-align: center;
    background-color: #fff!important;
    border: 1px solid #dfdfdf!important;
}
.companiesView .x_title {
    text-align: center;
}
/* .x_title h3{
       color: red;
    background: #2A3F54;
    font-family: "Helvetica Neue", Roboto, Arial, "Droid Sans", sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.471;
} */
.companiesLogo img{
        width: 100%;
    padding: 10px 0px;
    border: 1px solid #e3e3e3;
    margin-bottom: 10px;
}

.h4, h4 {
    font-size: 18px;
}


.h4, .h5, .h6, h4, h5, h6 {
    margin-top: 10px;
    margin-bottom: 10px;
}
button, input, select, textarea {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}
/* ul.bar_tabs {
    overflow: visible;
    background: #F5F7FA;
    height: 25px;
    margin: 21px 0 14px;
    padding-left: 14px;
    position: relative;
    z-index: 1;
    width: 100%;
    border-bottom: 1px solid #E6E9ED;
} */
.nav-tabs {
    border-bottom: 1px solid #ddd;
}

.nav {
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
}
.form-group {
    margin-bottom: 10px;
}
.has-feedback .form-control {
    padding-right: 42.5px;
}
.form-group .btn {
    margin-bottom: -6px;
}
.btn-primary {
    color: #fff;
    background-color: #337ab7;
    border-color: #2e6da4;
}
.form-group {
    margin-bottom: 10px;
}
    ul.bar_tabs>li.active a {
    border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/Sidebar/Profile.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,kCAAkC;IAClC,+BAA+B;IAC/B,gCAAgC;IAChC,UAAU;IACV,wBAAwB;AAC5B;AACA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,mCAAmC;AACvC;AACA;IACI,kBAAkB;AACtB;AACA;;;;;;;GAOG;AACH;QACQ,WAAW;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;;;;;;;;;;GAUG;AACH;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;IACI;IACA,mBAAmB;AACvB","sourcesContent":[".page-title {\r\n    width: 100%;\r\n    height: 65px;\r\n    padding: 10px 0;\r\n}\r\n.row {\r\n    margin-right: -10px;\r\n    margin-left: -10px;\r\n}\r\n.companiesViewleft {\r\n    text-align: center;\r\n    background-color: #fff!important;\r\n    border: 1px solid #dfdfdf!important;\r\n}\r\n.x_panel {\r\n    position: relative;\r\n    width: 100%;\r\n    margin-bottom: 10px;\r\n    padding: 10px 17px;\r\n    display: inline-block;\r\n    background: #fff;\r\n    border: 1px solid #E6E9ED;\r\n    -webkit-column-break-inside: avoid;\r\n    -moz-column-break-inside: avoid;\r\n    /* column-break-inside: avoid; */\r\n    opacity: 1;\r\n    transition: all .2s ease;\r\n}\r\n.x_title {\r\n    border-bottom: 2px solid #E6E9ED;\r\n    padding: 1px 5px 6px;\r\n    margin-bottom: 10px;\r\n}\r\n.companiesViewleft {\r\n    text-align: center;\r\n    background-color: #fff!important;\r\n    border: 1px solid #dfdfdf!important;\r\n}\r\n.companiesView .x_title {\r\n    text-align: center;\r\n}\r\n/* .x_title h3{\r\n       color: red;\r\n    background: #2A3F54;\r\n    font-family: \"Helvetica Neue\", Roboto, Arial, \"Droid Sans\", sans-serif;\r\n    font-size: 13px;\r\n    font-weight: 400;\r\n    line-height: 1.471;\r\n} */\r\n.companiesLogo img{\r\n        width: 100%;\r\n    padding: 10px 0px;\r\n    border: 1px solid #e3e3e3;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.h4, h4 {\r\n    font-size: 18px;\r\n}\r\n\r\n\r\n.h4, .h5, .h6, h4, h5, h6 {\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n}\r\nbutton, input, select, textarea {\r\n    font-family: inherit;\r\n    font-size: inherit;\r\n    line-height: inherit;\r\n}\r\n/* ul.bar_tabs {\r\n    overflow: visible;\r\n    background: #F5F7FA;\r\n    height: 25px;\r\n    margin: 21px 0 14px;\r\n    padding-left: 14px;\r\n    position: relative;\r\n    z-index: 1;\r\n    width: 100%;\r\n    border-bottom: 1px solid #E6E9ED;\r\n} */\r\n.nav-tabs {\r\n    border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.nav {\r\n    padding-left: 0;\r\n    margin-bottom: 0;\r\n    list-style: none;\r\n}\r\n.form-group {\r\n    margin-bottom: 10px;\r\n}\r\n.has-feedback .form-control {\r\n    padding-right: 42.5px;\r\n}\r\n.form-group .btn {\r\n    margin-bottom: -6px;\r\n}\r\n.btn-primary {\r\n    color: #fff;\r\n    background-color: #337ab7;\r\n    border-color: #2e6da4;\r\n}\r\n.form-group {\r\n    margin-bottom: 10px;\r\n}\r\n    ul.bar_tabs>li.active a {\r\n    border-bottom: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
